import WsProvider from './provider/WSProvider';

var serviceName = 'webservis';
var moduleName = 'muhasebe';

var talimatService = {
    dekontPath: WsProvider.dekontPath,
    imagePathBuyuk: WsProvider.imagePathBuyuk,
    imagePathOrta: WsProvider.imagePathOrta,
    imagePathKucuk: WsProvider.imagePathKucuk,
    belgePath: WsProvider.documentPath,
    path: WsProvider.path,
    getTemplates() {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            methodName: 'listele',
            serviceName: 'sablonTalimat',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    talimatEkle(sablonAdi, keys, sablon, template, bosSablon) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            methodName: 'MuhasebeEkle',
            serviceName: moduleName,
            ['data[sablonAdi]']: sablonAdi,
            ['data[sablon]']: template != 6 ? sablon : bosSablon,
        };
        // keys.forEach(item => item.model ? param[`data[${item.key}]`] = item.model : '')
        keys.forEach(item => param[`data[${item.key}]`] = item.model)
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    talimatGuncelle(icerik, muhasebeID, sayi, tarih, konu, aciklama) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            methodName: 'MuhasebeGuncelle',
            serviceName: moduleName,
            ['data[muhasebeID]']: muhasebeID,
            ['data[icerik]']: icerik || '',
            ['data[sayi]']: sayi || '',
            ['data[tarih]']: tarih || '',
            ['data[konu]']: konu || '',
            ['data[aciklama]']: aciklama || '',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    talimatListesi(durum, baslangic, limit) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[durum]': durum,
            'data[baslangic]': baslangic,
            'data[limit]': limit,
            serviceName: moduleName,
            methodName: 'MuhasebeListele',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    talimatStatusUpdate(muhasebeID, durum) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[muhasebeID]': muhasebeID,
            'data[durum]': durum,
            serviceName: moduleName,
            methodName: 'DurumDegistir',
        };

        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    talimatDetay(muhasebeID) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[muhasebeID]': muhasebeID,
            serviceName: moduleName,
            methodName: 'MuhasebeDetay',
        };

        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    dekontEkle(muhasebeID, dekont, islem) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[muhasebeID]': muhasebeID,
            'belge': dekont,
            serviceName: moduleName,
            methodName: islem = 'update' ? 'DekontEkle' : 'DekontGuncelle',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return result;
    },
    // talimatEkle(sayi, tarih, konu, banka, alici, iban, tutar, aciklama, sablon, sablon2) {
    //     console.log('talimat ekle ')
    //     console.log('sayi:', sayi)
    //     console.log('tarih:', tarih)
    //     console.log('konu:', konu)
    //     console.log('banka:', banka)
    //     console.log('alici:', alici)
    //     console.log('iban:', iban)
    //     console.log('tutar:', tutar)
    //     console.log('aciklama:', aciklama)
    //     console.log('sablon:', sablon)
    //     console.log('sablon2:', sablon2)
    //     var userDataDemirag = localStorage.getItem('userDataDemirag');
    //     var param = {
    //         token: userDataDemirag,
    //         methodName: 'muhasebeEkle',
    //         serviceName: moduleName,
    //         'data[sayi]': sayi,
    //         'data[tarih]': tarih,
    //         'data[konu]': konu,
    //         'data[banka]': banka,
    //         'data[alici]': alici,
    //         'data[iban]': iban,
    //         'data[tutar]': tutar,
    //         'data[aciklama]': aciklama,
    //         'data[sablon]': sablon,
    //         [sablon2 && `data[sablon2]`]: sablon2,
    //     };
    //     console.log('talimatEkle', param)
    //     var result = new Promise(function (resolve, reject) {
    //         WsProvider.ajaxPost(serviceName, param)
    //             .then(response => {
    //                 resolve(response);
    //             })
    //             .catch(error => {
    //                 reject(error);
    //             });
    //     });
    //     return result;
    // },
};
export default talimatService;
